import type { Variants } from "framer-motion";

/** Staggered container — children use `shopGridItemVariants`. */
export const shopGridContainerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.065,
      delayChildren: 0.05,
    },
  },
};

export const shopGridItemVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 26,
    scale: 0.965,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

export const shopGridContainerReduced: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.02, delayChildren: 0 },
  },
};

export const shopGridItemReduced: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.18, ease: "easeOut" },
  },
};
